export default __webpack_public_path__ + "static/media/b_wdt_c_5.f66943d4.mp3";